<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import CaptainEmptyState from './CaptainEmptyState.vue';

const emit = defineEmits(['click']);

const { t } = useI18n();

const STEPS = [
  ['CONNECT', 'i-lucide-inbox'],
  ['ANSWER', 'i-lucide-message-circle'],
  ['HANDOFF', 'i-lucide-user-round'],
];

const steps = computed(() =>
  STEPS.map(([key, icon]) => ({
    icon,
    title: t(`CAPTAIN.INBOXES.EMPTY_STATE.STEPS.${key}.TITLE`),
    description: t(`CAPTAIN.INBOXES.EMPTY_STATE.STEPS.${key}.DESCRIPTION`),
  }))
);
</script>

<template>
  <CaptainEmptyState
    icon="i-lucide-inbox"
    :title="t('CAPTAIN.INBOXES.EMPTY_STATE.TITLE')"
    :subtitle="t('CAPTAIN.INBOXES.EMPTY_STATE.SUBTITLE')"
    :steps="steps"
  >
    <template #actions>
      <Button
        :label="t('CAPTAIN.INBOXES.CREATE_INBOX')"
        icon="i-lucide-plus"
        @click="emit('click')"
      />
    </template>
  </CaptainEmptyState>
</template>
